import { callAPI } from "./api";

export const getOrderPdf = async (orderNumber, documentType, storeId, source = null) => {
    const sourcePart = source ? `&source=${source}` : '';
    const route = `getOrderDocument/${orderNumber}?documentType=${documentType}${sourcePart}`;
    try {
        const data = await callAPI(route);
        return data;
    } catch (error) {
        throw error;
    }
};